<template>
  <div class="question-response-text is-flex flex-wrap gap-1">
    <div
      v-for="response in sorted"
      :key="response.name"
      class="grow page-width is-flex-col align-start"
      :style="{ flexBasis: '15em' }"
    >
      <span
        class="text-white px-1 is-size-7"
        :style="{ backgroundColor: assignedColors[response.name], borderRadius: '0.5em 0.5em 0 0' }"
      >
        {{ response.name }}
      </span>

      <div
        class="border p-3"
        :style="{ borderColor: assignedColors[response.name], borderRadius: '0 0.5em 0.5em 0.5em' }"
      >
        <p>{{ response.response }}</p>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['responses', 'assignedColors'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    colors() {
      return this.$root.$data.COLORS;
    },
    sorted() {
      if (!this.responses) return [];
      const data = [...this.responses];
      return data.sort((a, b) => a.response.length - b.response.length);
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
